export default __webpack_public_path__ + "static/media/login.702fb4f2.png";